import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile,map } from "rxjs/operators";
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";

import {
    FilterDateDiff
    ,FilterSecToTime
    ,FilterDist
} from "src/app/shared/filter";
import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FvmsCommonService
    ,FvmsUtilService
    ,FvmsApiDtgReportDangerService
} from "src/app/shared/service";

@Component({
    templateUrl: './dtg.report.danger.day.detail.component.html'
    ,styleUrls: ["./dtg.report.danger.day.detail.component.scss"]
    ,providers:[FilterDateDiff,FilterSecToTime,FilterDist]
})
export class DtgReportDangerDayDetailComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    dtgUnitId:string;
    dtgDriveRuleType:string;
    dtgCarType:number;
    dtgRegDtFrom:string;
    pagingInfo:PagingInfo = new PagingInfo();
    listItem:any[]=[];
    ruleConf:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,public activeModal: NgbActiveModal
        ,private activatedRoute: ActivatedRoute
        ,private fvmsApiDtgReportDangerService:FvmsApiDtgReportDangerService
        ,private filterDateDiff:FilterDateDiff
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private router: Router
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.dtgUnitId = this.activatedRoute.snapshot.params.dtgUnitId;
        this.dtgDriveRuleType = this.activatedRoute.snapshot.params.dtgDriveRuleType;
        this.dtgCarType = this.activatedRoute.snapshot.params.dtgCarType;
        this.dtgRegDtFrom = this.activatedRoute.snapshot.params.dtgRegDtFrom;
    }

    ngOnInit() {
        // this.reloadListRuleConfig();
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    getSearchInfo(){
        return {
            dtgUnitId:this.dtgUnitId
            ,dtgDriveRuleType:this.dtgDriveRuleType
            ,searchDateFrom:this.dtgRegDtFrom
        };
    }

    reloadListItem(){
        this.fvmsApiDtgReportDangerService.getListReportDangerDriveHis(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("reloadListItem",apiResponse);
                    this.listItem = [];
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        this.pagingInfo = apiResponse.pagingInfo;
                        this.ruleConf = this.listItem[0];
                        this.calcDiff();
                    }
                }
            });
    }

    calcDiff(){
        if(this.listItem){
            let sizeList = this.listItem.length;
            for(let a=0;a<sizeList;a++){
                let itemCurr = this.listItem[a];
                if(a === 0){
                    itemCurr["dtgSpeedDiff"] = 0;
                    itemCurr["dtgGpsDirectionDiff"] = 0;
                }else{
                    let itemPre = this.listItem[a-1];
                    itemCurr["dtgSpeedDiff"] = itemCurr.dtgSpeed - itemPre.dtgSpeed;
                    itemCurr["dtgGpsDirectionDiff"] = this.calcAngleDiff(itemPre.dtgGpsDirection,itemCurr.dtgGpsDirection);
                }
            }
        }
    }

    calcAngleDiff(angleA:number=0,angleB:number=0) {
        return 180 - Math.abs(Math.abs(angleA - angleB) - 180);
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.reloadListItem();
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }
}
